'use client';
import PaginatedGrid, { GridType } from '@components/PaginatedGrid';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { memo } from 'react';
import GridItem from './_AmbassadorsGridItem';
import Section from '@repo/ui/src/components/Section';
import { fetchAmbassadorsClient } from './fetchCategoryDataClient';

import type { Data } from '@typings/productGrid';

interface AmbassadorsGridProps {
  title?: string;
  pluralType?: string;
  _data?: Data;
}

const AmbassadorsGrid = ({ title, pluralType, _data }: AmbassadorsGridProps) => {
  const { locale } = useCurrentUrl();

  const loadData = async ({ page }: { page: number }): Promise<any> => {
    return await fetchAmbassadorsClient({ locale, page });
  };

  return (
    <Section gutterX basePadding white className="max-w-screen-xl mx-auto">
      {title && <h2 className="tra-text-web-heading-2">{title}</h2>}
      <p className="md:flex md:justify-end tra-text-web-body-xl pr-6">
        {_data?.nbHits || 0} {pluralType || 'Ambassadors'}
      </p>
      <PaginatedGrid
        _data={_data}
        loadData={loadData}
        GridItemComponent={GridItem}
        type={GridType.Ambassador}
        disableBorder
        className="bg-white"
        content={{}}
        hideAddToCartButton={false}
      />
    </Section>
  );
};

export default memo(AmbassadorsGrid);
